import {
  getSceneResponsiveLayout,
  type ResponsiveLayoutConfig,
} from '../../../shared/layout/index.js';

export const NUMBER_KINGDOM_DISTRICT_WIDTH = 1280;
export const NUMBER_KINGDOM_DISTRICT_HEIGHT = 720;

const DISTRICT_LAYOUT: ResponsiveLayoutConfig = {
  logicalSize: {
    width: NUMBER_KINGDOM_DISTRICT_WIDTH,
    height: NUMBER_KINGDOM_DISTRICT_HEIGHT,
  },
  visibilityScaleMode: 'envelop',
  safeInsets: { top: 14, right: 18, bottom: 14, left: 18 },
  compactViewportHeight: 700,
  compactVisibleWidth: 1100,
};

export function getNumberKingdomDistrictLayout(scene: Phaser.Scene) {
  return getSceneResponsiveLayout(scene, DISTRICT_LAYOUT);
}

export function configureNumberKingdomDistrictRenderer(scene: Phaser.Scene) {
  const parentWidth = scene.scale.parentSize.width || window.innerWidth;
  const parentHeight = scene.scale.parentSize.height || window.innerHeight;
  const cssScale = Math.max(
    parentWidth / NUMBER_KINGDOM_DISTRICT_WIDTH,
    parentHeight / NUMBER_KINGDOM_DISTRICT_HEIGHT,
  );
  const pixelRatio = Phaser.Math.Clamp(window.devicePixelRatio || 1, 1, 2);
  const renderScale = Phaser.Math.Clamp(cssScale * pixelRatio, 1, 2);

  scene.scale.scaleMode = Phaser.Scale.ENVELOP;
  scene.scale.autoCenter = Phaser.Scale.NO_CENTER;
  scene.scale.displaySize.setAspectMode(Phaser.Scale.ENVELOP);
  scene.scale.setGameSize(
    Math.round(NUMBER_KINGDOM_DISTRICT_WIDTH * renderScale),
    Math.round(NUMBER_KINGDOM_DISTRICT_HEIGHT * renderScale),
  );
  scene.scale.refresh();
  scene.game.canvas.style.marginLeft = '0px';
  scene.game.canvas.style.marginTop = '0px';
  scene.cameras.main
    .setZoom(renderScale)
    .centerOn(NUMBER_KINGDOM_DISTRICT_WIDTH * 0.5, NUMBER_KINGDOM_DISTRICT_HEIGHT * 0.5);
  return renderScale;
}
